export default "__VITE_ASSET__BKyH5Ifx__"